import ProductFormWithPreview from './ProductFormWithPreview'

export default ProductFormWithPreview
